import { useTranslation } from 'react-i18next';

import { useAccessControlGuard } from '$shared/custom-hooks/useAccessControlGuard';

import { TabsNavigationSidecar } from '$components/tabs';
import type { TabNavigationRoute } from '$components/tabs/tabs.types';

export function UserDetailNavigation() {
  const { t } = useTranslation();
  const canViewPreferences = useAccessControlGuard('VIEW_DEVICE_OVERVIEW');

  const userDetailSidecarRoutes: TabNavigationRoute[] = [
    {
      label: t('userDetail.profile.tabTitle'),
      path: 'profile',
      icon: 'user',
    },
  ];

  if (canViewPreferences) {
    userDetailSidecarRoutes.push({
      label: t('userDetail.preferences.tabTitle'),
      path: 'preferences',
      icon: 'preferences',
    });
  }

  return <TabsNavigationSidecar routes={userDetailSidecarRoutes} />;
}
